import React, { useState } from "react";
import { Box, Typography, Stack, Slide } from "@mui/material";
import SubscriptionRow from "../../components/SubscriptionRow";
import PageHeader from "./../../components/PageHeader";
import {
  fullName,
  getErrorString,
  getUserDetail,
} from "./../../constants/function";
import Loader from "./../../components/Loader";
import notifier from "./../../components/Notifier";
import ApiService from "./../../services/api-service";
import NoData from "./../../components/Nodata";
import SuccessPopup from "../../components/SuccessPopup";
import { useTranslation } from "react-i18next";
export default function Subscription() {
  const { t } = useTranslation("common");
  const [message, setMessage] = useState(t("success.message7"));
  const [open, setOpen] = useState(false);

  const userDetails = getUserDetail();
  const [subscriptions, setSubscriptions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const getSubscriptions = async (id) => {
    try {
      setLoading(true);
      const response = await ApiService.GET_SUBSCRIPTIONS(id);
      setSubscriptions([...response["result"]]);
      setLoading(false);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };

  React.useEffect(() => {
    if (userDetails["_id"]) {
      getSubscriptions(userDetails["_id"]);
    }
  }, []);
  /**
   * @param  {} artistId
   * UNSUBSCRIBE_ARTIST an artist
   */
  const unSubscribe = async (artistId, index) => {
    try {
      setLoading(true);
      const response = await ApiService.UNSUBSCRIBE_ARTIST({
        artistId: artistId,
        currency: "siki",
      });
      setMessage(t("success.message4"));
      setOpen(true);
      getSubscriptions(userDetails["_id"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  return (
    <Box sx={{ padding: "0 18px 100px 18px" }}>
      {/* <PageHeader title="My Subscription" /> */}
      <Typography className="fs-20">{t("mySubscription.title")}</Typography>
      <hr style={{ borderColor: "#262626" }} />
      <Stack spacing={2} mt={2}>
        {subscriptions.length > 0 ? (
          subscriptions.map((subscription, index) => (
            <SubscriptionRow
              key={index}
              title={fullName(subscription["artistDetails"])}
              status={subscription["status"]}
              action={subscription["status"]}
              actionColor={"error"}
              statusColor={"success"}
              data={subscription}
              onAction={(userId, index) => unSubscribe(userId, index)}
              index={index}
            />
          ))
        ) : (
          <NoData lable={t("mySubscription.noData")} />
        )}
      </Stack>
      {open ? (
        <SuccessPopup
          message={message}
          open={open}
          handleClose={() => setOpen(false)}
        />
      ) : null}
      {loading ? <Loader /> : null}
    </Box>
  );
}
